import { render, staticRenderFns } from "./QrInstructions.vue?vue&type=template&id=5e03b144&scoped=true"
import script from "./QrInstructions.vue?vue&type=script&lang=js"
export * from "./QrInstructions.vue?vue&type=script&lang=js"
import style0 from "./QrInstructions.vue?vue&type=style&index=0&id=5e03b144&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e03b144",
  null
  
)

export default component.exports